import _ from "lodash";

export const type = {
  LOG_IN: "LOG_IN",
  LOG_OUT: "LOG_OUT",
  CHANGE_LOADING: "CHANGE_LOADING",
  CHANGE_LIST_MONTH: "CHANGE_LIST_MONTH",
  CHANGE_SELECTED_MONTH: "CHANGE_SELECTED_MONTH",
  CHANGE_DETAIL: "CHANGE_DETAIL",
  CHANGE_SELECTED_TAB: "CHANGE_SELECTED_TAB",
};

export const reducer = (state, action) => {
  switch (action.type) {
    case type.LOG_IN:
      return {
        ...state,
        loggedIn: true,
      };

    case type.LOG_OUT:
      localStorage.removeItem("token");
      return { ...state, loggedIn: false };

    case type.CHANGE_LIST_MONTH:
      return {
        ...state,
        listMonth: action.data,
        selectedMonth: {
          ...state.selectedMonth,
          value:
            action.data.length > 0
              ? action.data[0].year + "." + action.data[0].month
              : null,
          year: action.data.length > 0 ? action.data[0].year : 0,
          month: action.data.length > 0 ? action.data[0].month : 0,
        },
      };

    case type.CHANGE_SELECTED_MONTH:
      return {
        ...state,
        selectedMonth: {
          ...state.selectedMonth,
          value: action.data,
          year: action.data.split(".")[0],
          month: action.data.split(".")[1],
        },
        selectedTab: 0,
      };

    case type.CHANGE_DETAIL:
      var detail = action.data;
      var info = null;
      var sumDebit = 0;
      var sumCredit = 0;

      if (detail.length > 0) {
        //var main = detail.find((a) => a.code <= 3);
        var main = detail.filter((a) => a.code <= 3).pop();

        info = main !== undefined ? main : null;
        _.map(detail, (item) => {
          if (item?.debit !== null) sumDebit += item?.debit;
          if (item?.credit !== null) sumCredit += item?.credit;
        });
        info = {
          ...info,
          sumDebit: sumDebit,
          sumCredit: sumCredit,
          sumDiffrence: sumDebit - sumCredit,
        };
      }
      return {
        ...state,
        detail: detail,
        detailFiltered: detail,
        info: info,
        loading: false,
      };

    case type.CHANGE_SELECTED_TAB:
      var detailFiltered = state.detail;
      if (action.data === 1)
        detailFiltered = state.detail.filter((a) => a.debit !== null);
      if (action.data === 2)
        detailFiltered = state.detail.filter((a) => a.credit !== null);
      return {
        ...state,
        selectedTab: action.data,
        detailFiltered: detailFiltered,
      };

    case type.CHANGE_LOADING:
      return {
        ...state,
        loading: action.data,
      };

    default:
      return state;
  }
};
